export default __webpack_public_path__ + "static/media/IBMPlexMono-Regular-Cyrillic.6956fe0f.woff2";